import Typography from "@mui/material/Typography";

export default function NotFound() {
  return (
    <>
      <Typography variant="h1">404 Page Not Found</Typography>
    </>
  );
}
